import dateFnsFormat from "date-fns/format";
import dateFnsParse from "date-fns/parse";
import {DateUtils} from "react-day-picker";

export function getYearFromTimestamp(timestamp) {
    let a = new Date(timestamp * 1000);
    return a.getFullYear();
}

export function convertTimestampToDate(timestamp) {
    let a = new Date(timestamp * 1000);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let year = a.getFullYear();
    let month = months[a.getMonth()];
    let date = a.getDate();
    return date + ' ' + month + ' ' + year;
}

export function convertTimestampToTime(timestamp) {
    let a = new Date(timestamp * 1000);
    let hour = (a.getHours() + '').padStart(2, "0");
    let min = (a.getMinutes() + '').padStart(2, "0");
    return hour + ':' + min;
}

export function dateFormat(units) {
    return units === 'metric' ? 'dd.MM.yyyy' : 'MM/dd/yyyy'
}

export function formatDate(date, format, locale) {
    return dateFnsFormat(date, format, {locale});
}

export function parseDate(str, format, locale) {
    const parsed = dateFnsParse(str, format, new Date(), {locale});
    if (DateUtils.isDate(parsed)) {
        return parsed;
    }
    return undefined;
}